import React from "react";

/**
 * Campaign + affiliate selectors for the CSV wizard mapping step.
 * The campaign selection is what pins the batch to a client.
 */
export default function CsvCampaignPicker({
  campaigns, campaignId, setCampaignId,
  affiliates, affiliateId, setAffiliateId,
}) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="label-mono">Campaign (assigns client)</label>
        <select data-testid="csv-campaign"
          className="w-full border border-black px-2 py-1.5 mt-1"
          value={campaignId} onChange={(e) => setCampaignId(e.target.value)}>
          <option value="">— none —</option>
          {campaigns.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <div>
        <label className="label-mono">Source affiliate</label>
        <select data-testid="csv-affiliate"
          className="w-full border border-black px-2 py-1.5 mt-1"
          value={affiliateId} onChange={(e) => setAffiliateId(e.target.value)}>
          <option value="">— none —</option>
          {affiliates.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
      </div>
    </div>
  );
}
